var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("el-form", { attrs: { "label-position": "top" } }, [
        _c("div", { staticClass: "contactum_card" }, [
          _c("div", { staticClass: "contactum_card_head" }, [
            _c("h2", { staticClass: "title" }, [
              _vm._v(" Google reCAPTCHA Settings ")
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "text" }, [
              _vm._v(
                " Contactum integrates with reCAPTCHA, a free service that protects your website from spam and abuse. Please note,\n          these settings are required only if you decide to use the reCAPTCHA field. Read more about reCAPTCHA.  "
              ),
              _c(
                "a",
                {
                  attrs: {
                    href: "http://www.google.com/recaptcha/",
                    target: "_blank"
                  }
                },
                [_vm._v("Read more about reCAPTCHA")]
              )
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "text" }, [
              _c("b", [
                _vm._v("Please generate API key and API secret using reCAPTCHA")
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "contactum_card_body" },
            [
              _c(
                "el-form-item",
                { staticClass: "ff-form-item" },
                [
                  _c(
                    "template",
                    { slot: "label" },
                    [
                      _vm._v(
                        "\n                reCAPTCHA Version\n                "
                      ),
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: {
                            placement: "bottom-start",
                            "popper-class": "ff_tooltip_wrap"
                          }
                        },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "content" }, slot: "content" },
                            [
                              _c("p", [
                                _vm._v(
                                  "Please select which reCAPTCHA version you would like to use"
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("i", {
                            staticClass:
                              "ff-icon ff-icon-info-filled text-primary"
                          })
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-radio-group",
                    {
                      on: { change: _vm.load },
                      model: {
                        value: _vm.reCaptcha.api_version,
                        callback: function($$v) {
                          _vm.$set(_vm.reCaptcha, "api_version", $$v)
                        },
                        expression: "reCaptcha.api_version"
                      }
                    },
                    [
                      _c("el-radio", { attrs: { label: "v2_visible" } }, [
                        _vm._v("Version 2 (Visible reCAPTCHA)")
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: "v3_invisible" } }, [
                        _vm._v("Version 3 (Invisible reCAPTCHA)")
                      ])
                    ],
                    1
                  )
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { staticClass: "ff-form-item" },
                [
                  _c(
                    "template",
                    { slot: "label" },
                    [
                      _vm._v("Site Key\n                "),
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: {
                            placement: "bottom-start",
                            "popper-class": "ff_tooltip_wrap"
                          }
                        },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "content" }, slot: "content" },
                            [
                              _c("p", [
                                _vm._v(
                                  "Enter your reCAPTCHA Site Key, if you do not have a key you can register for one at the provided link. reCAPTCHA is a free service."
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("i", {
                            staticClass:
                              "ff-icon ff-icon-info-filled text-primary"
                          })
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-input", {
                    on: { change: _vm.load },
                    model: {
                      value: _vm.reCaptcha.siteKey,
                      callback: function($$v) {
                        _vm.$set(_vm.reCaptcha, "siteKey", $$v)
                      },
                      expression: "reCaptcha.siteKey"
                    }
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { staticClass: "ff-form-item" },
                [
                  _c(
                    "template",
                    { slot: "label" },
                    [
                      _vm._v("Secret Key\n                "),
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: {
                            placement: "bottom-start",
                            "popper-class": "ff_tooltip_wrap"
                          }
                        },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "content" }, slot: "content" },
                            [
                              _c("p", [
                                _vm._v(
                                  "Enter your reCAPTCHA Secret Key, if you do not have a key you can register for one at the provided link, reCAPTCHA is a free service."
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("i", {
                            staticClass:
                              "ff-icon ff-icon-info-filled text-primary"
                          })
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-input", {
                    attrs: { type: "password" },
                    on: { change: _vm.load },
                    model: {
                      value: _vm.reCaptcha.secretKey,
                      callback: function($$v) {
                        _vm.$set(_vm.reCaptcha, "secretKey", $$v)
                      },
                      expression: "reCaptcha.secretKey"
                    }
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c("template", { slot: "label" }, [_vm._v("Validate Keys")]),
                  _vm._v(" "),
                  _c("div", {
                    attrs: {
                      id: "reCaptcha",
                      "data-sitekey": _vm.reCaptcha.siteKey,
                      "data-size": _vm.size
                    }
                  })
                ],
                2
              ),
              _vm._v(" "),
              _vm.reCaptcha_status && !_vm.disabled
                ? _c("div", { attrs: { size: "sm", type: "success-soft" } }, [
                    _c("p", [_vm._v("Your reCAPTCHA is valid")])
                  ])
                : _vm._e()
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "mt-4" },
          [
            _c(
              "el-button",
              {
                attrs: {
                  type: "primary",
                  icon: "el-icon-success",
                  disabled: _vm.disabled,
                  loading: false
                },
                on: { click: _vm.save }
              },
              [_vm._v("Save Settings")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                attrs: {
                  type: "danger",
                  icon: "ff-icon ff-icon-trash",
                  clearing: false
                },
                on: { click: _vm.clearSettings }
              },
              [_vm._v("Clear Settings")]
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }